import React from "react";

const STYLES = {
  Pending: "bg-yellow-100 text-yellow-800",
  Fulfilled: "bg-blue-100 text-blue-800",
  Delivered: "bg-green-100 text-green-800",
  Undelivered: "bg-red-100 text-red-800",
  "In Transit": "bg-indigo-100 text-indigo-800",
  Cancelled: "bg-gray-200 text-gray-700",
  Approved: "bg-green-100 text-green-800",
  Rejected: "bg-red-100 text-red-800",
  "Undelivered / RTO": "bg-red-100 text-red-800",
  active: "bg-green-100 text-green-800",
  inactive: "bg-gray-200 text-gray-700",
  "Manual Order": "bg-slate-100 text-slate-700",
  "Claimed Order": "bg-purple-100 text-purple-800",
  COD: "bg-orange-100 text-orange-800",
  Prepaid: "bg-emerald-100 text-emerald-800",
  "Partial COD": "bg-amber-100 text-amber-800",
  Claimed: "bg-purple-100 text-purple-800",
  // B2B statuses
  "Pending Approval": "bg-yellow-100 text-yellow-800",
  "Invoice Uploaded": "bg-blue-100 text-blue-800",
  "Edit Requested": "bg-amber-100 text-amber-800",
  "Info Requested": "bg-orange-100 text-orange-800",
};

export default function StatusBadge({ status, testid }) {
  const cls = STYLES[status] || "bg-gray-100 text-gray-700";
  return (
    <span
      data-testid={testid}
      className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${cls}`}
    >
      {status || "-"}
    </span>
  );
}
